import { Mui } from "@osu/react-ui";
import { Fragment, useRef } from "react";
import { useGetPreferencesQuery } from "../../../../services/graphql/api";
import Form from "./Form.js";

function QuickLinks() {
  useGetPreferencesQuery();
  const autocompleteRef = useRef();

  return (
    <Fragment>
      <Mui.Typography variant="h2">Quick Links</Mui.Typography>
      <Mui.Typography className="padding-top-1" variant="body2">
        Rearrange or remove links to customize the quick links on your dashboard. To add new links, select one or more options from the dropdown and click Add.
      </Mui.Typography>
      <Form autocompleteRef={autocompleteRef} />
    </Fragment>
  );
}

export default QuickLinks;
